import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrow'
})
export class ArrowPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value < 1 && value > -1) {
      return ' → ';
    }
    if (value > 5) {
      return ' ↑ ';
    }
    if (value > 1 && value < 5) {
      return ' ↗ ';
    }
    if (value < -1 && value > -5 ) {
      return ' ↘ ';
    }
    if (value < -5) {
      return ' ↓ ';
    }
  }
}
